module.exports = __webpack_public_path__ + "img/baymak_logo.58c16ec9.png";